export const HOST = [
    'https://esop-test.tigerfintech.com',
    'https://www.tigeresop.com',
    'https://esop-test.tigerfintech.com'
];

export const API = {
    web: '/web/',
    m: '/m/'
};
